import { render, staticRenderFns } from "./DepositsProducts.vue?vue&type=template&id=621e09d4"
import script from "./DepositsProducts.vue?vue&type=script&lang=js"
export * from "./DepositsProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports